$(document).ready(function(){ 
      var removeClass = true;
      $('.filter-menu-top').on('click', '.filter-toggle', function(e) { 
        e.preventDefault();

        $( this).next(".inner-filter").toggleClass('inner-filter-active');
        $( this ).parent("div.filter-menu-top").siblings().find('.inner-filter').removeClass('inner-filter-active');
        removeClass = false;
      });
      $(".inner-filter").click(function() {
        removeClass = false;
      });
      $("html").click(function () {
        if (removeClass) {
          $(".inner-filter").removeClass('inner-filter-active');
        }
        removeClass = true;
      });

     $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').hide();
    $('.tab-content:first').show();

    // Click function
    $('#tabs-nav li').click(function(){
      $('#tabs-nav li').removeClass('active');
      $(this).addClass('active');
      $('.tab-content').hide();

      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn();
      return false;
    }); 

  $('.collection-product-slick').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 3000,
        settings: {
         arrows: true,
          slidesToShow: 4 
        }
      },
      {
        breakpoint: 1300,
        settings: {
        arrows: true,
          slidesToShow: 4 
        }
      },
      {
        breakpoint: 992,
        settings: {
        arrows: true,
          slidesToShow: 3 
        }
      },
      {
        breakpoint: 768,
        settings: {
        arrows: true,
          slidesToShow: 3 
        }
      },
      {
        breakpoint: 720,
        settings: {
        arrows: true,
          slidesToShow: 2
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
    /*
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4 
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3 
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3 
        }
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 2
        }
      }
      
    ]*/
  }).on('setPosition', function (event, slick) {
    if ($(window).width() > 575) {
        //console.log("Window width is greater than 575px.");
       slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    }
  });

   $(".announcement-bar.lazy.slider").slick({
          lazyLoad: 'ondemand',
          infinite: true,
          loop : true,
          autoplay: true,
          // autoplaySpeed: 10000,
          //vertical: true,
          //verticalSwiping: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          cssEase: 'linear',
          initialSlide: 2,
          //verticalMode: 'bottom',
        });
    $(window).resize(function() {
          if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
           // some code..
            $('.desktop_menu').hide();
            $('.mobile_menu').show();
          } else {
            $('.mobile_menu').hide();
            $('.desktop_menu').show();
          }
        });

        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
         // some code..
          $('.desktop_menu').hide();
          $('.mobile_menu').show();
        } else {
          $('.mobile_menu').hide();
          $('.desktop_menu').show();
        }

  $('.moreless-button').click(function() {
    $('.moretext').slideToggle();
    if ($('.moreless-button').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });

  $('.product-slider').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  $('.info-product-slider').slick({
  dots: false,
  autoplay: true,
  infinite: true,
  speed: 200,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,  
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow:1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
}); 